import React from 'react';
import { Flex, Text, Box } from '@chakra-ui/react';
import { Stack as StackIcon } from 'phosphor-react';
import { PageBox } from '../../../../../components/pageBox';
import { ReturnButton } from '../../../../../components/buttons/ReturnButton';
import { IcmsCompanyPicker } from '../shared/IcmsCompanyPicker';

export function IcmsAcumuladoresHomePage() {
  return (
    <PageBox>
      <Flex align="center" pb={5}>
        <ReturnButton previousPage="/modulesHome/supervisor/icms" />
        <Box h="full">
          <Flex align="center" justify="center" borderRadius="full" p={3} bg="#F3E5F5">
            <StackIcon color="#9C27B0" className="size-8" />
          </Flex>
        </Box>
        <Flex direction="column" justify="center" gap={1} pl={2}>
          <Text fontWeight="bold" fontSize="16px">
            Acumuladores
          </Text>
          <Text fontSize="12px" color="gray.500">
            Selecione uma empresa para classificar os acumuladores (DIFAL, ST, simples, etc.).
          </Text>
        </Flex>
      </Flex>
      <IcmsCompanyPicker basePath="/modulesHome/supervisor/icms/acumuladores/empresa" />
    </PageBox>
  );
}
